export default __webpack_public_path__ + "static/assets/7916ec3f0cfae2ab9a4f0e404f1dc2a3.png";